import { render, staticRenderFns } from "./ModalCreateBenefit.vue?vue&type=template&id=748c1f8a&scoped=true"
import script from "./ModalCreateBenefit.vue?vue&type=script&lang=js"
export * from "./ModalCreateBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c1f8a",
  null
  
)

export default component.exports